import React from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import FormViewButton from 'components/Common/Buttons/FormViewButton';
import FormWorkflowStages from 'common/Workflows/FormWorkflowStages';

const CustomerFormList = ({ permissions, customer, onDeleteForm }) => {
  const getAccountName = (item) => {
    if (item === null || (!item.accountNumber && !item.accountName)) {
      return 'N/A';
    }

    let accountName = item.accountNumber;

    if (!accountName) {
      accountName = item.accountName;
    } else if (item.accountName !== null && item.accountName !== accountName) {
      accountName = `${ accountName } - ${ item.accountName }`;
    }

    return accountName;
  };

  return (
    <div>
      <table className="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>Form Type</th>
            <th>Date Uploaded</th>
            <th>Account</th>
            <th width="300px">Expiration Date</th>
            <th>Signed Date</th>
            <th>Workflow</th>
            <th>Original Filename</th>
            <th>View/Action</th>
          </tr>
        </thead>
        <tbody>
          { (customer != null && customer.forms != null && customer.forms.length > 0)
            && customer.forms.sort((a, b) => {
              if (moment(b.validUntil).isSame(a.validUntil)) {
                return moment(b.dateUploaded).isAfter(a.dateUploaded) ? 1 : -1;
              }
              return moment(b.validUntil).isAfter(a.validUntil) ? 1 : -1;
            }).map(formData => formData != null && <tr key={ formData.id }>
              <td align="center">{ formData.formTypeDescription }</td>
              <td align="center">{ moment(formData.dateUploaded).format('MMM DD, YYYY') }</td>
              <td align="center">
                { formData != null && formData.accountId != null
                  && AccessControl.hasPermission(permissions, [ActivityPerms.accountPageView, ActivityPerms.accountEdit])
                  ? <Link className="text-bold" to={ `/account/${ formData.accountId }` }> { getAccountName(formData) } </Link>
                  : getAccountName(formData) }
                { formData == null && formData.accountId == null && 'N/A' }
              </td>
              <td align="center">{(() => {
                if (!formData.isValid) {
                  return 'N/A - Invalid Form';
                }
                if (formData.validUntil && formData.validUntil !== null) {
                  const expiryReason = formData.expiryReasonDescription !== null ? `(${ formData.expiryReasonDescription })` : '';
                  if (formData.validUntil.includes('9999')) {
                    return `Evergreen ${ expiryReason }`;
                  }
                  return `${ moment(formData.validUntil).format('MMM DD, YYYY') } ${ expiryReason }`;
                }
                return '';
              })()}
              </td>
              <td align="center"> {formData.dateSigned !== null ? moment(formData.dateSigned).format('MMM DD, YYYY') : ''} </td>
              <td align="center">{ formData.workflowStageDescription ?? 'N/A' }</td>
              <td>{ formData.originalFileName }</td>
              <td className="form-action-btn-group">
                {
                  (
                    (formData.isOnlineForm
                      && AccessControl.hasPermission(
                        permissions,
                        [
                          ActivityPerms.electronicView,
                          ActivityPerms.electronicValidate
                        ]
                      )
                    ) || (
                      !formData.isOnlineForm
                      && AccessControl.hasPermission(
                        permissions,
                        [
                          ActivityPerms.scannedView,
                          ActivityPerms.scannedEdit,
                          ActivityPerms.scannedValidate
                        ]
                      )
                    )
                  ) && formData.formType && formData.formType.toLowerCase() !== 'unknown' && <FormViewButton
                    content={ <span className="icon icon-apps" /> }
                    className="btn btn-sm"
                    title="Reopen"
                    formId={ formData.id }
                    accountId={ formData.accountId }
                    form={ formData }
                    permissions={ permissions }
                  />
                }
                {
                  (
                    ((
                      ((formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteCompleteForms]))
                      || (!formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteCompleteForms])))
                      && formData.workflowStage === FormWorkflowStages.Complete)
                    || (
                      ((formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteInReviewForms]))
                      || (!formData.isOnlineForm && AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteInReviewForms])))
                      && formData.workflowStage !== FormWorkflowStages.Complete))
                    && formData.formType && formData.formType.toLowerCase() !== 'unknown'
                  )
                  && <button
                    className="btn btn-sm btn-danger"
                    type="button"
                    title="Delete form"
                    onClick={ () => onDeleteForm(formData) }
                  >
                    <span className="icon icon-delete" />
                  </button>
                }
              </td>
            </tr>) }
          { (!customer || !customer.forms || customer.forms.length === 0)
            && <tr><td colSpan="8" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
        </tbody>
      </table>
    </div>
  );
};

CustomerFormList.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  customer: PropTypes.shape(),
  onDeleteForm: PropTypes.func.isRequired
};

CustomerFormList.defaultProps = {
  permissions: null,
  customer: {
    forms: []
  }
};

export default CustomerFormList;
